export const BUILT_BY_IMMIGRANTS_VIDEO_LINK =
  'https://vimeo.com/1078623605/19f48e7699';
export const MISSION_STATEMENT_VIDEO_LINK =
  'https://vimeo.com/1080842874/7381262327';
